<script>
import Batch from '@/layer/components/Batch.vue';

export default {
  components: {
    Batch,
  },

  props: {
    batchName: { type: String, required: true },
  },
}
</script>

<template>
  <div>
    <batch :batch-name="this.batchName" />
  </div>
</template>



// WEBPACK FOOTER //
// src/layer/views/BatchView.vue